document.addEventListener('DOMContentLoaded', function() {
	if(document.querySelector('#about-complex') && document.querySelector(`[data-category="${parseInt(window.location.hash.slice(1))}"]`)){
		//triger click on this element
		document.querySelector(`[data-category="${parseInt(window.location.hash.slice(1))}"]`).click();
	}
})